import {eTipoPermissao} from "@/enums/ePermissoes";

export default [
 {
  description: "Ação do Projeto",
  path: "/prestacaocontas/pcoprojeto/:pcoProjetoId/acao",
  parent: "pcoprojeto",
  name: "pcoprojeto_acao",
  component: () => import("@/views/prestacaocontas/pcoacao/CadastroComGrid.vue"),
  meta: {
   permissions: [eTipoPermissao.CONVENIOPROJETOSNOVO_MENU_1500100199],
  },
  goesToMenu: false,
 },
]
